/**
 * directives.combobox Module
 *
 * Description
 */
var app = angular.module('directives.printReceipt');

app.directive('printReceipt', ['$state', function ($state) {
    var tmplUrl;
    
    try {
        tmplUrl = require('../templates/'+$state.current.name.replace('pages.','')+'.html');//looking for template with moduleName
    }catch(e){
        tmplUrl = require('../templates/index.html')//if error, use default template
    }

    return {
        template: tmplUrl,
        controller: function ($scope, PortalApi, Localization) {
            $scope.getPayDocumentsList = function (payment) {
                payment.loader = true;

                if($scope.billsHistory){

                    // PortalApi.printBill(data).then(function (response) {
                    PortalApi.getPayDocumentsList(payment.id).then(function (response) {

                        payment.data = angular.copy(response.plain());

                    }).finally(function () {
                        payment.loader = false;
                        $scope.historyLoader = false;
                    });
                } else {
                    // change request for multi docs
                    PortalApi.getPayDocumentsList(payment.id).then(function (response) {
                        // remove [] if resporse was array
                        payment.data = response.plain();
                        // payment.data = [angular.copy(response.plain())];
                        // payment.data.push(angular.copy(response.plain())); //remove that line when was right response

                    }).finally(function () {
                        payment.loader = false;
                        $scope.historyLoader = false;
                    });
                }
            };
            $scope.showDocList = false;
            // new fnc for print doc when we have right response
            $scope.printItemClick = function(item) {
            };
        }
    };
}]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/printReceipt/directives/receipt.directive.js
 ** module id = 210
 ** module chunks = 1
 **/